export default (videoUrl?: string): string => {
    // Test cases
    // https://www.youtube.com/watch?v=soIGV6BszcM
    // https://www.youtube.com/watch?v=soIGV6BszcM&foo=bar
    // http://youtube.com/watch?v=j1ofke8z8wy
    // https://www.youtube.com/embed/wvUl43PJlXk
    // https://www.youtube.com/watch?v=soIGV6BszcM?foo=bar
    // https://youtube.com/embed/wvUl43PJlXk
    // https://youtu.be/wvUl43PJlXk
    // https://youtu.be/wvUl43PJlXk?foo=bar

    const regEx = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((?:\w|-){11})(.*?)$/g;
    const parsedVideoUrl = videoUrl?.replace(regEx, "$1") || "";
    return parsedVideoUrl;
};